// Busca de cliente no cadastro por nome e/ou CPF/CNPJ, usada nas telas de Processos e da Agenda.
// O back procura o nome pelo texto inteiro ("claudia braga" não acharia "CLAUDIA DE AVILA BRAGA"): busca pela maior
// palavra e confere as demais aqui (palavrasDoNome/nomeConfere, testadas em processos.test.js).
//
// GET /clientes/cpfcnpj/{doc}  -> cliente | vazio
// GET /clientes/nome/{texto}   -> [clientes] | 204
import axios from 'axios';
import config from '../config/config';
import { palavrasDoNome, nomeConfere } from './processos';

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('jwtToken')}` } });

// Clientes achados pelo documento e/ou pelo nome, sem repetir. null = nada para buscar (menos de 3 letras/números).
export async function buscarClientes({ nome = '', documento = '' }) {
  const { API_BASE_URL } = config;
  const digitos = String(documento || '').replace(/\D/g, '');
  const palavras = palavrasDoNome(nome);
  if (digitos.length < 3 && !palavras.length) return null;

  const achados = [];
  if (digitos.length >= 3) {
    try {
      const { data } = await axios.get(`${API_BASE_URL}/clientes/cpfcnpj/${digitos}`, auth());
      if (data) achados.push(data);
    } catch (error) {
      // não achou pelo documento: fica o resultado pelo nome
    }
  }
  if (palavras.length) {
    const maior = palavras.reduce((a, b) => (b.length > a.length ? b : a));
    const { data } = await axios.get(`${API_BASE_URL}/clientes/nome/${encodeURIComponent(maior)}`, auth());
    (Array.isArray(data) ? data : [])
      .filter((c) => nomeConfere(c.nome, palavras))
      .forEach((c) => { if (!achados.some((a) => a.idCliente === c.idCliente)) achados.push(c); });
  }
  return achados;
}

// Um campo só (nome OU CPF/CNPJ): números com pontuação de documento vão como CPF/CNPJ; o resto, como nome
export function buscarClientesPorTermo(termo) {
  const texto = String(termo || '').trim();
  const ehDocumento = /^[\d.\-/\s]+$/.test(texto);
  return buscarClientes(ehDocumento ? { documento: texto } : { nome: texto });
}
